import { render, staticRenderFns } from "./revitalize.vue?vue&type=template&id=1fa974af&scoped=true&"
import script from "./revitalize.vue?vue&type=script&lang=js&"
export * from "./revitalize.vue?vue&type=script&lang=js&"
import style0 from "./revitalize.vue?vue&type=style&index=0&id=1fa974af&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa974af",
  null
  
)

export default component.exports